import { useHead } from '@unhead/react'
import type { CohesionSnippetConfig } from '@redventures/cohesion-utils-react'
import { ChooseCohesionConfig } from '@strata-monorepo/shared-ui/utils/Cohesion/ChooseCohesionConfig'
import { CTXPCohesionConfig } from '@strata-monorepo/shared-ui/utils/Cohesion/CTXPCohesionConfig'
import { SOECohesionConfig } from '@strata-monorepo/shared-ui/utils/Cohesion/SOECohesionConfig'
import { TXERCohesionConfig } from '@strata-monorepo/shared-ui/utils/Cohesion/TXERCohesionConfig'
import { useEffect, useState } from 'react'

interface DeferredCohesionScriptProps {
  children: React.ReactNode
}

const DeferredCohesionScript: React.FC<DeferredCohesionScriptProps> = ({ children }) => {
  const [hasRegisteredHead, setHasRegisteredHead] = useState<boolean>(false)

  const configToSiteMap: Record<string, CohesionSnippetConfig> = {
    '/choose-energy': ChooseCohesionConfig,
    '/choose-texas-power': CTXPCohesionConfig,
    '/save-on-energy': SOECohesionConfig,
    '/texas-electric-rates': TXERCohesionConfig,
  }

  const sitePaths = Object.keys(configToSiteMap)
  const defaultPath = '/choose-energy'

  const pathname = window.location.pathname
  const pathNoEndSlash = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname

  // Get the config for the current path or fall back to default, with type assertion
  const config = (configToSiteMap[pathNoEndSlash] ||
    configToSiteMap[defaultPath]) as CohesionSnippetConfig

  if (sitePaths.includes(pathNoEndSlash)) {
    console.log(`Loading Cohesion config for ${pathNoEndSlash}`)
  } else {
    console.log(`No matching Cohesion config for ${pathNoEndSlash}. Defaulting to ${defaultPath}`)
  }

  const isDevelopment = import.meta.env.VITE_BUILD_ENV === 'development'

  useHead({
    script: isDevelopment
      ? [
          {
            id: 'cohesion-script',
            innerHTML: `
          !function (co, h, e, s, i, o, n) {
            var d = 'documentElement'; var a = 'className'; h[d][a] += ' preampjs fusejs'; n.k = e; co._Cohesion = n; co._Preamp = { k: s, start: new Date }; co._Fuse = { k: i };
            co._Tagular = { k: o };[e, s, i, o].map(function (x) { co[x] = co[x] || function () { (co[x].q = co[x].q || []).push([].slice.call(arguments)) } });
            h.addEventListener('DOMContentLoaded', function () {
              co.setTimeout(function () { var u = h[d][a]; h[d][a] = u.replace(/ ?preampjs| ?fusejs/g, '') }, 3e3);
              co._Preamp.docReady = co._Fuse.docReady = !0
            }); var z = h.createElement('script'); z.async = 1;
            z.src = 'https://cdn.cohesionapps.com/cohesion/cohesion-latest.min.js'; h.head.appendChild(z);
          }(window, document, 'cohesion', 'preamp', 'fuse', 'tagular', ${JSON.stringify(config)})`,
            type: 'text/javascript',
          },
        ]
      : [],
  })

  useEffect(() => {
    setHasRegisteredHead(true)
  }, [])

  if (!hasRegisteredHead) {
    return null
  }

  return <>{children}</>
}

export default DeferredCohesionScript
